<div class="upload-docs">
  <div class="upload-docs__content">
    <p class="title-f">{{ "uploadDocs.title" | translate }}</p>
    <p>{{ "uploadDocs.desc" | translate }}</p>

    <mat-card class="upload-docs__card">
      <div fxLayout="row" fxLayoutAlign="space-between">
        <div>
          <div fxFlex>
            <img src="assets/icons/id-icon.png" alt="id" class="desktop-icon" />
          </div>
          <div style="max-width: 300px">
            <div class="title-container">
              <div class="title">{{ "common.uploadMykad" | translate }}</div>
              <div class="desc">
                {{ "common.uploadMykadDesc" | translate }}
              </div>
            </div>
          </div>
        </div>

        <div style="text-align: right">
          <input
            type="file"
            accept="image/*, application/pdf"
            multiple
            id="ID"
            name="ID"
            (change)="handleFileInput($event)"
            style="display: none"
            />
            @if (errorActivatedPolicy === false) {
              <button
                mat-stroked-button
                class="mt-sm"
                >
                <label
                  for="ID"
							style="
								display: flex;
								justify-content: center;
								align-items: center;
							"
                  >
                  <mat-icon class="">add_circle</mat-icon
                    >{{ "common.upload" | translate }}
                  </label>
                </button>
              }
            </div>
          </div>
          @if (fileToShow?.ID.length) {
            <div class="filename">
              <mat-divider></mat-divider>
              <div class="pt-sm">
                @for (item of fileToShow?.ID; track item) {
                  <div>
                    {{ item.file.name | truncate : [10, "..."] }}
                    @if (errorActivatedPolicy === false) {
                      <button
                        mat-icon-button
                        (click)="deleteFile('ID', item.file)"
                        >
                        <mat-icon>cancel</mat-icon>
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </mat-card>

        <mat-card>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div>
              <div fxFlex>
                <img
                  src="assets/icons/id-icon.png"
                  alt="lou"
                  class="desktop-icon"
                  />
                </div>
                <div style="max-width: 300px">
                  <div class="title-container">
                    <div class="title">
                      {{ "common.uploadLOU" | translate }} / {{ "common.uploadVSO" | translate }}
                    </div>
                    <div class="desc">
                      {{ "common.uploadLOUVSODesc" | translate }}
                    </div>
                  </div>
                </div>
              </div>

              <div style="text-align: right">
                <input
                  type="file"
                  accept="application/pdf"
                  multiple
                  id="LOU"
                  name="LOU"
                  (change)="handleFileInput($event)"
                  style="display: none"
                  />
                  <!-- <div
                  class="desc color-link"
                  (click)="showSampleDialog('LOU')"
                  >
                  {{ "uploadDocs.viewSample" | translate }}
                </div> -->
                @if (errorActivatedPolicy === false) {
                  <button
                    mat-stroked-button
                    class="mt-sm"
                    >
                    <label
                      for="LOU"
							style="
								display: flex;
								justify-content: center;
								align-items: center;
							"
                      >
                      <mat-icon class="">add_circle</mat-icon
                        >{{ "common.upload" | translate }}
                      </label>
                    </button>
                  }
                </div>
              </div>
              @if (fileToShow?.LOU.length) {
                <div class="filename">
                  <mat-divider></mat-divider>
                  <div class="pt-sm">
                    @for (item of fileToShow?.LOU; track item) {
                      <div>
                        {{ item.file.name | truncate : [10, "..."] }}
                        @if (errorActivatedPolicy === false) {
                          <button
                            mat-icon-button
                            (click)="deleteFile('LOU', item.file)"
                            >
                            <mat-icon>cancel</mat-icon>
                          </button>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </mat-card>

            <mat-card>
              <div fxLayout="row" fxLayoutAlign="space-between">
                <div>
                  <div fxFlex>
                    <img
                      src="assets/image/vehicle-grant.png"
                      alt="grant"
                      class="desktop-icon"
                      />
                    </div>
                    <div>
                      <div class="title-container">
                        <div class="title">
                          {{ "uploadDocs.vehicleGrant" | translate }}
                        </div>
                        <div class="desc">
                          {{ "uploadDocs.vehicleGrantDesc" | translate }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style="text-align: right">
                    <input
                      type="file"
                      accept="image/*, application/pdf"
                      id="VehicleGrant"
                      name="VehicleGrant"
                      (change)="handleFileInput($event)"
                      style="display: none"
                      />
                      <div
                        class="desc color-link"
                        (click)="showSampleDialog('VehicleGrant')"
                        >
                        {{ "uploadDocs.viewSample" | translate }}
                      </div>
                      @if (errorActivatedPolicy === false) {
                        <button
                          mat-stroked-button
                          class="mt-sm"
                          >
                          <label
                            for="VehicleGrant"
							style="
								display: flex;
								justify-content: center;
								align-items: center;
							"
                            >
                            <mat-icon class="">add_circle</mat-icon
                              >{{ "common.upload" | translate }}
                            </label>
                          </button>
                        }
                      </div>
                    </div>
                    @if (fileToShow?.VehicleGrant.length) {
                      <div class="filename">
                        <mat-divider></mat-divider>
                        <div class="pt-sm">
                          @for (item of fileToShow?.VehicleGrant; track item) {
                            <div>
                              {{ item.file.name | truncate : [10, "..."] }}
                              @if (errorActivatedPolicy === false) {
                                <button
                                  mat-icon-button
                                  (click)="deleteFile('VehicleGrant', item.file)"
                                  >
                                  <mat-icon>cancel</mat-icon>
                                </button>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </mat-card>

                  <mat-card>
                    <div fxLayout="row">
                      <div>
                        <img
                          src="assets/image/car-icon.png"
                          alt="car-icon"
                          class="desktop-icon"
                          />
                        </div>
                        <div>
                          <div fxLayoutAlign="space-between">
                            <div class="title-container">
                              <div class="title">
                                {{ "uploadDocs.vehiclePhoto" | translate }}
                              </div>
                              <div class="desc">
                                {{ "uploadDocs.vehiclePhotoDesc" | translate }}
                              </div>
                            </div>
                            <div
                              class="desc color-link"
                              style="text-align: right"
                              (click)="showSampleDialog('VehiclePhoto')"
                              >
                              {{ "uploadDocs.viewSample" | translate }}
                            </div>
                          </div>

                          <mat-card>
                            <input
                              type="file"
                              accept="image/*, application/pdf"
                              id="FrontCar"
                              name="FrontCar"
                              (change)="handleFileInput($event)"
                              style="display: none"
                              />
                              <div fxLayout="row" fxLayoutAlign="space-between">
                                <p class="mdDesc-f bold">{{ "uploadDocs.fcar" | translate }}</p>
                                <div>
                                  @if (errorActivatedPolicy === false) {
                                    <button
                                      mat-stroked-button
                                      >
                                      <label
                                        for="FrontCar"
										style="
											display: flex;
											justify-content: center;
											align-items: center;
										"
                                        >
                                        <mat-icon class="color-dark-blue">add_circle</mat-icon
                                          >{{ "common.upload" | translate }}
                                        </label>
                                      </button>
                                    }
                                  </div>
                                </div>
                                @if (fileToShow?.FrontCar.length) {
                                  <div
                                    class="filename vehicle-photo"
                                    >
                                    @for (item of fileToShow?.FrontCar; track item) {
                                      <div>
                                        {{ item.file.name | truncate : [10, "..."] }}
                                        @if (errorActivatedPolicy === false) {
                                          <button
                                            mat-icon-button
                                            (click)="deleteFile('FrontCar', item.file)"
                                            >
                                            <mat-icon>cancel</mat-icon>
                                          </button>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              </mat-card>
                              <mat-card>
                                <input
                                  type="file"
                                  accept="image/*, application/pdf"
                                  id="BackCar"
                                  name="BackCar"
                                  (change)="handleFileInput($event)"
                                  style="display: none"
                                  />
                                  <div fxLayout="row" fxLayoutAlign="space-between">
                                    <p class="mdDesc-f bold">{{ "uploadDocs.bcar" | translate }}</p>

                                    <div>
                                      @if (errorActivatedPolicy === false) {
                                        <button
                                          mat-stroked-button
                                          >
                                          <label
                                            for="BackCar"
										style="
											display: flex;
											justify-content: center;
											align-items: center;
										"
                                            >
                                            <mat-icon class="">add_circle</mat-icon
                                              >{{ "common.upload" | translate }}
                                            </label>
                                          </button>
                                        }
                                      </div>
                                    </div>
                                    @if (fileToShow?.BackCar.length) {
                                      <div
                                        class="filename vehicle-photo"
                                        >
                                        @for (item of fileToShow?.BackCar; track item) {
                                          <div>
                                            {{ item.file.name | truncate : [10, "..."] }}
                                            @if (errorActivatedPolicy === false) {
                                              <button
                                                mat-icon-button
                                                (click)="deleteFile('BackCar', item.file)"
                                                >
                                                <mat-icon>cancel</mat-icon>
                                              </button>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                  </mat-card>
                                  <mat-card>
                                    <input
                                      type="file"
                                      accept="image/*, application/pdf"
                                      id="LeftCar"
                                      name="LeftCar"
                                      (change)="handleFileInput($event)"
                                      style="display: none"
                                      />
                                      <div fxLayout="row" fxLayoutAlign="space-between">
                                        <p class="mdDesc-f bold">
                                          {{ "uploadDocs.lside" | translate }}
                                        </p>
                                        <div>
                                          @if (errorActivatedPolicy === false) {
                                            <button
                                              mat-stroked-button
                                              >
                                              <label
                                                for="LeftCar"
										style="
											display: flex;
											justify-content: center;
											align-items: center;
										"
                                                >
                                                <mat-icon class="">add_circle</mat-icon
                                                  >{{ "common.upload" | translate }}
                                                </label>
                                              </button>
                                            }
                                          </div>
                                        </div>
                                        @if (fileToShow?.LeftCar.length) {
                                          <div
                                            class="filename vehicle-photo"
                                            >
                                            @for (item of fileToShow?.LeftCar; track item) {
                                              <div>
                                                {{ item.file.name | truncate : [10, "..."] }}
                                                @if (errorActivatedPolicy === false) {
                                                  <button
                                                    mat-icon-button
                                                    (click)="deleteFile('LeftCar', item.file)"
                                                    >
                                                    <mat-icon>cancel</mat-icon>
                                                  </button>
                                                }
                                              </div>
                                            }
                                          </div>
                                        }
                                      </mat-card>
                                      <mat-card>
                                        <input
                                          type="file"
                                          accept="image/*, application/pdf"
                                          id="RightCar"
                                          name="RightCar"
                                          (change)="handleFileInput($event)"
                                          style="display: none"
                                          />
                                          <div fxLayout="row" fxLayoutAlign="space-between">
                                            <p class="mdDesc-f bold">
                                              {{ "uploadDocs.rside" | translate }}
                                            </p>
                                            <div>
                                              @if (errorActivatedPolicy === false) {
                                                <button
                                                  mat-stroked-button
                                                  >
                                                  <label
                                                    for="RightCar"
										style="
											display: flex;
											justify-content: center;
											align-items: center;
										"
                                                    >
                                                    <mat-icon class="">add_circle</mat-icon
                                                      >{{ "common.upload" | translate }}
                                                    </label>
                                                  </button>
                                                }
                                              </div>
                                            </div>
                                            @if (fileToShow?.RightCar.length) {
                                              <div
                                                class="filename vehicle-photo"
                                                >
                                                @for (item of fileToShow?.RightCar; track item) {
                                                  <div>
                                                    {{ item.file.name | truncate : [10, "..."] }}
                                                    @if (errorActivatedPolicy === false) {
                                                      <button
                                                        mat-icon-button
                                                        (click)="deleteFile('RightCar', item.file)"
                                                        >
                                                        <mat-icon>cancel</mat-icon>
                                                      </button>
                                                    }
                                                  </div>
                                                }
                                              </div>
                                            }
                                          </mat-card>
                                        </div>
                                      </div>
                                    </mat-card>

                                    <button
                                      mat-flat-button
                                      class="mt-md full-width"
                                      color="primary"
                                      (click)="handleSubmit()"
                                      [disabled]="fileToUpload.length === 0"
                                      >
                                      {{ "common.submit" | translate }}
                                    </button>
                                  </div>
                                </div>
